document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    const decreaseBtn = event.target.closest('[data-qty-decrease]');
    const increaseBtn = event.target.closest('[data-qty-increase]');

    if (decreaseBtn) {
      const inputId = decreaseBtn.getAttribute('data-input-id');
      const input = document.getElementById(inputId);
      if (!input || input.disabled) return;

      const min = parseInt(input.getAttribute('min') || '1', 10);
      const current = parseInt(input.value || '1', 10);
      input.value = Math.max(min, current - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (increaseBtn) {
      const inputId = increaseBtn.getAttribute('data-input-id');
      const input = document.getElementById(inputId);
      if (!input || input.disabled) return;

      const maxAttr = input.getAttribute('max');
      const max = maxAttr ? parseInt(maxAttr, 10) : null;
      const min = parseInt(input.getAttribute('min') || '1', 10);
      const current = parseInt(input.value || String(min), 10);
      const next = current + 1;

      input.value = max ? Math.min(max, next) : next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function (event) {
    const input = event.target.closest('.pv-matrix__qty-input');
    if (!input) return;

    const min = parseInt(input.getAttribute('min') || '1', 10);
    const maxAttr = input.getAttribute('max');
    const max = maxAttr ? parseInt(maxAttr, 10) : null;
    let value = parseInt(input.value || String(min), 10);

    if (Number.isNaN(value) || value < min) value = min;
    if (max && value > max) value = max;

    input.value = value;
  });

  const dialogs = document.querySelectorAll('[data-pv-image-dialog]');

  dialogs.forEach(function (dialog) {
    const imgTarget = dialog.querySelector('[data-pv-image-target]');
    const closeBtn = dialog.querySelector('[data-pv-image-close]');

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close();
      });
    }

    dialog.addEventListener('click', function (event) {
      const rect = dialog.getBoundingClientRect();
      const clickedInside =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;

      if (!clickedInside) {
        dialog.close();
      }
    });

    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-pv-image-trigger]');
      if (!trigger) return;

      if (typeof dialog.showModal !== 'function') return;

      const section = trigger.closest('.pv-matrix');
      if (!section || !section.contains(dialog)) return;

      event.preventDefault();

      const src = trigger.getAttribute('data-pv-image-src');
      const alt = trigger.getAttribute('data-pv-image-alt') || '';

      if (imgTarget) {
        imgTarget.src = src;
        imgTarget.alt = alt;
      }

      dialog.showModal();
    });
  });
});